<template>
  <div class="copyright" v-if="response.settings.display_branding">
    <div class="icon" v-if="!response.branding.custom_branding">
      <img src="../../assets/logo.svg" alt="" />
    </div>
    <a :href="response.branding.url" target="_blank" class="text">
      <p class="mb-0">{{ response.branding.name }}</p>
    </a>
  </div>
</template>

<script>
export default {
  name: "Branding",
  data() {
    return {response:null};
  },
  created() {
    this.response = this.$session.get("response");
    //  console.log()
  },
  mounted() {
    window.addEventListener(
      "message",
      (event) => {
        if (event.origin === "http://localhost:8100" || event.origin === "https://vkstg.larkbase.com" || event.origin === "https://app.vouchkick.com") {
          if (event.data.settings) {
            this.response = this.$session.get("response");
            var this_pointer = this;
            setTimeout(function() {
              this_pointer.$helpers.resizeIframeEvent();
            }, 300);
          } else if (event.data.option) {
            this.response = this.$session.get("response");
          }
        }
      },
      false
    );
  },
};
</script>
<style scoped lang="scss">
.copyright {
  display: flex;
  align-items: flex-end;
  margin-top: 10px;
  .icon {
    margin-right: 4.84px;
    display: flex;
    align-items: flex-end;
    padding-bottom: 3px;
  }
  .text {
    p {
      font-family: "Mulish", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 10px;
      line-height: 15px;
      color: #8997b1;
    }
  }
}
</style>
